export class TabLottiGaraModel {
  desLottoGara:	string  
  codLotto:	number
  idLottoGara: number
}